import "@babel/polyfill";
import cssVars from 'css-vars-ponyfill';
import * as $ from "jquery";
import Config from "./config/Config";
import PerformanceElement from "./pages/PerformanceElement";
import CoolingElement from "./pages/CoolingElement";
import OverClockingElement from "./pages/OverClockingElement";
import ConnectivityElement from "./pages/ConnectivityElement";
import PersonalizeElement from "./pages/PersonalizeElement";
import SpecElement from "./pages/SpecElement";
import ScrollContainer from "./ScrollContainer";
import {ViewEvent} from "./event/EventStaus";

export module App {

    $(function () {
        cssVars();
        Config.init();

        const scrollContainer = new ScrollContainer($(window));
        scrollContainer.emitter.on(ViewEvent.ON_SCROLL, (data: any) => {
            if (elements) {
                elements.map((item: any) => {
                    if (item.target != null) item.target.update(data.scrollTop);
                });
            }
        });
        $(window).on("resize", e => {
            resizeOverviewGuide();
            if (elements) {
                elements.map((item: any) => {
                    if (item.target != null) item.target.resize();
                });
            }
        });

        resizeOverviewGuide();
        setTimeout(() => {
            initPages();
        }, 1500);
    });

    function resizeOverviewGuide() {
        let baseW: number = $("#special-sectionOverview, #sectionOverview").width();
        let tw: number = window.innerWidth > 2560 ? 2560 : window.innerWidth;
        let tx: number = (baseW - tw) * 0.5;
        $("#x299ROG").css({
            'left': tx + 'px',
            'width': tw + 'px'
        });
    }

    let elements: any[] = [
        {id: 'spec', class: SpecElement, target: null},
        {id: 'performance', class: PerformanceElement, target: null},
        {id: 'cooling', class: CoolingElement, target: null},
        {id: 'overclocking', class: OverClockingElement, target: null},
        {id: 'connectivity', class: ConnectivityElement, target: null},
        {id: 'personalize', class: PersonalizeElement, target: null}
    ];
    const initPages = () => {
        elements.map((item: any) => {
            const ElementClass = item.class;
            const name = '.s_' + item.id;
            item.target = new ElementClass($(name));
        });

        $(".preloading").fadeOut(500);
    }
}
